import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API } from '../api/client';
import { useApi } from '../api/useApi';

export default function ThankYouEmail() {
  const { callId } = useParams<{ callId: string }>();
  const navigate = useNavigate();
  const [approved, setApproved] = useState(false);

  const { data: fi, loading: fiLoading, error: fiError } = useApi<any>(() => API.getFI(callId!), [callId]);
  const { data: draft, loading: dLoading, error: dError } = useApi<any>(
    () => API.thankYouDraft(callId!, callId!), [callId],
  );

  if (fiLoading || dLoading) return <div className="phil-loading">Loading…</div>;
  if (fiError || dError || !fi || !draft) {
    return <div className="phil-error">Unable to load thank-you email. {fiError ?? dError}</div>;
  }

  return (
    <>
      <div className="breadcrumb">
        <a onClick={() => navigate(`/fi/${fi.id}`)}>{fi.name}</a>
        <span className="bc-sep">›</span>
        <span>Thank-You Email</span>
      </div>

      <div className="page-header">

        <h1>Thank-You + FIL Brief + Referral Link</h1>
        <p className="subtitle">Sent once approved.</p>
      </div>

      <div className="email-box">
        <div className="email-field">
          <span className="email-label">From:</span>
          <span className="email-val">{draft.from}</span>
        </div>
        <div className="email-field">
          <span className="email-label">To:</span>
          <span className="email-val">{draft.to}</span>
        </div>
        <div className="email-field">
          <span className="email-label">Subject:</span>
          <span className="email-val" style={{ fontWeight: 500 }}>{draft.subject}</span>
        </div>
        <div className="email-field">
          <span className="email-label">Attach:</span>
          <span className="email-val" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 5, fontSize: 12 }}>
              📄 {draft.attachment}
            </span>
          </span>
        </div>
        <div className="email-body">{draft.body}</div>
        <div className="email-footer">
          <button className="btn btn-outline btn-sm" onClick={() => navigate('/admin/email-templates')}>✎ Edit</button>
          <button
            className={`btn btn-sm ${approved ? 'btn-outline' : 'btn-success'}`}
            style={{ marginLeft: 'auto' }}
            onClick={() => { API.thankYouSend(draft.draftId).catch(() => {}); setApproved(true); }}
          >
            {approved ? '✓ Sent' : '✓ Approve & Send'}
          </button>
        </div>
      </div>

      {approved && (
        <div style={{ marginTop: 10, padding: '10px 14px', background: '#dcfce7', borderRadius: 7, fontSize: 13, color: '#166534' }}>
          ✓ Thank-you email sent · Trigger fired: queued for director approval via Human in the Loop CTA
        </div>
      )}

      <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
        <button className="btn btn-outline btn-sm" onClick={() => navigate(`/fi/${fi.id}/notes`)}>← Notes</button>
      </div>
    </>
  );
}
